import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { firstValueFrom } from 'rxjs';
import { filter, take, timeout } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Esperar a que el servicio termine de inicializar (máximo 5 segundos)
  if (!authService.initialized()) {
    try {
      await firstValueFrom(
        toObservable(authService.initialized).pipe(
          filter(initialized => initialized === true),
          take(1),
          timeout({ first: 5000 })
        )
      );
    } catch (error) {
      console.error('Timeout esperando inicialización del AuthService');
    }
  }

  if (authService.isAuthenticated()) {
    return true;
  }

  router.navigate(['/login']);
  return false;
};

